const filteredCount = (form) => {
  const raw = form.dataset.participantsBulkFilteredCount
  const value = Number.parseInt(raw || "0", 10)
  return Number.isFinite(value) ? value : 0
}

const selectAllFilteredField = (form) =>
  form.querySelector("[data-participants-bulk-select-all-filtered-field]")

const isSelectAllFiltered = (form) => selectAllFilteredField(form)?.value === "1"

const setSelectAllFiltered = (form, enabled) => {
  const field = selectAllFilteredField(form)
  if (field) field.value = enabled ? "1" : "0"
}

const updateBulkBar = (form) => {
  const rows = [...form.querySelectorAll("[data-participants-bulk-row]")]
  const selected = rows.filter((input) => input.checked)
  const bar = form.querySelector("[data-participants-bulk-bar]")
  const countLabel = form.querySelector("[data-participants-bulk-count]")
  const deleteSubmit = form.querySelector("[data-participants-bulk-submit]")
  const selectAll = form.querySelector("[data-participants-bulk-select-all]")
  const selectAllFilteredBtn = form.querySelector("[data-participants-bulk-select-all-filtered]")
  const clearFilteredBtn = form.querySelector("[data-participants-bulk-clear-filtered]")
  const actionButtons = form.querySelectorAll("[data-participants-bulk-action]")
  const approveBtn = form.querySelector("[data-participants-bulk-approve]")
  const rejectBtn = form.querySelector("[data-participants-bulk-reject]")
  const exportBtn = form.querySelector("[data-participants-bulk-export]")
  const totalFiltered = filteredCount(form)
  const allFiltered = isSelectAllFiltered(form)
  const pageFullySelected = rows.length > 0 && selected.length === rows.length
  const selectionCount = allFiltered ? totalFiltered : selected.length
  const hasSelection = selectionCount > 0
  const statuses = selected.map((input) => input.dataset.registrationStatus).filter(Boolean)
  const canApprove =
    !allFiltered &&
    statuses.length > 0 &&
    statuses.every(
      (status) => status === "submitted" || status === "rejected" || status === "expired"
    )
  const canReject =
    !allFiltered &&
    statuses.length > 0 &&
    statuses.every(
      (status) =>
        status === "submitted" ||
        status === "approved" ||
        status === "expired" ||
        status === "draft"
    )

  if (bar) bar.hidden = !hasSelection

  if (countLabel) {
    if (allFiltered) {
      countLabel.textContent =
        selectionCount <= 1
          ? `${selectionCount} résultat filtré sélectionné`
          : `${selectionCount} résultats filtrés sélectionnés`
    } else {
      countLabel.textContent =
        selectionCount <= 1 ? `${selectionCount} sélectionné` : `${selectionCount} sélectionnés`
    }
  }

  if (deleteSubmit) {
    deleteSubmit.disabled = !hasSelection
    deleteSubmit.textContent =
      selectionCount <= 1 ? "Supprimer" : "Supprimer la sélection"
    const singular = form.dataset.participantsBulkDeleteSingular || "l’enregistrement"
    const plural = form.dataset.participantsBulkDeletePlural || "enregistrements"
    const disclaimer = form.dataset.participantsBulkDeleteDisclaimer
    let confirmMessage =
      selectionCount <= 1
        ? `Supprimer ${singular} sélectionné ?`
        : `Supprimer les ${selectionCount} ${plural} sélectionnés ?`
    if (disclaimer) confirmMessage = `${confirmMessage}\n\n${disclaimer}`
    deleteSubmit.dataset.confirm = confirmMessage
  }

  if (exportBtn) {
    exportBtn.textContent =
      selectionCount <= 1 ? "Exporter" : "Exporter la sélection"
  }

  actionButtons.forEach((button) => {
    button.disabled = !hasSelection
  })

  if (approveBtn) {
    approveBtn.hidden = !canApprove
    approveBtn.disabled = !canApprove
    approveBtn.textContent =
      selectionCount <= 1 ? "Valider" : "Valider la sélection"
    approveBtn.dataset.confirm =
      selectionCount <= 1
        ? "Valider l’inscription sélectionnée ?"
        : `Valider les ${selectionCount} inscriptions sélectionnées ?`
  }

  if (rejectBtn) {
    rejectBtn.hidden = !canReject
    rejectBtn.disabled = !canReject
    rejectBtn.textContent =
      selectionCount <= 1 ? "Rejeter" : "Rejeter la sélection"
    rejectBtn.dataset.confirm =
      selectionCount <= 1
        ? "Rejeter l’inscription sélectionnée ?"
        : `Rejeter les ${selectionCount} inscriptions sélectionnées ?`
  }

  if (selectAll) {
    selectAll.checked = pageFullySelected || allFiltered
    selectAll.indeterminate = !allFiltered && selected.length > 0 && selected.length < rows.length
  }

  if (selectAllFilteredBtn) {
    const show =
      !allFiltered && pageFullySelected && totalFiltered > rows.length
    selectAllFilteredBtn.hidden = !show
    if (show) {
      selectAllFilteredBtn.textContent =
        totalFiltered <= 1
          ? "Sélectionner le résultat filtré"
          : `Sélectionner les ${totalFiltered} résultats filtrés`
    }
  }

  if (clearFilteredBtn) {
    clearFilteredBtn.hidden = !allFiltered
  }
}

const bindParticipantsBulk = (form) => {
  if (form.dataset.participantsBulkBound === "true") return
  form.dataset.participantsBulkBound = "true"

  const selectAll = form.querySelector("[data-participants-bulk-select-all]")
  if (selectAll) {
    selectAll.addEventListener("change", () => {
      setSelectAllFiltered(form, false)
      form.querySelectorAll("[data-participants-bulk-row]").forEach((input) => {
        input.checked = selectAll.checked
      })
      updateBulkBar(form)
    })
  }

  const selectAllFilteredBtn = form.querySelector("[data-participants-bulk-select-all-filtered]")
  if (selectAllFilteredBtn) {
    selectAllFilteredBtn.addEventListener("click", (event) => {
      event.preventDefault()
      setSelectAllFiltered(form, true)
      form.querySelectorAll("[data-participants-bulk-row]").forEach((input) => {
        input.checked = true
      })
      updateBulkBar(form)
    })
  }

  const clearFilteredBtn = form.querySelector("[data-participants-bulk-clear-filtered]")
  if (clearFilteredBtn) {
    clearFilteredBtn.addEventListener("click", (event) => {
      event.preventDefault()
      setSelectAllFiltered(form, false)
      updateBulkBar(form)
    })
  }

  form.addEventListener("change", (event) => {
    if (!event.target.matches("[data-participants-bulk-row]")) return
    setSelectAllFiltered(form, false)
    updateBulkBar(form)
  })

  form.addEventListener("submit", (event) => {
    if (isSelectAllFiltered(form)) return
    const selected = form.querySelectorAll("[data-participants-bulk-row]:checked")
    if (selected.length === 0) event.preventDefault()
  })

  const resendSubmit = form.querySelector("[data-participants-bulk-resend]")
  if (resendSubmit) {
    resendSubmit.addEventListener("click", () => {
      const count = isSelectAllFiltered(form)
        ? filteredCount(form)
        : form.querySelectorAll("[data-participants-bulk-row]:checked").length
      resendSubmit.dataset.confirm =
        count <= 1
          ? "Renvoyer le mail de confirmation à l’exposant sélectionné ?"
          : `Renvoyer le mail de confirmation aux ${count} exposants sélectionnés ?`
    })
  }

  updateBulkBar(form)
}

const bindParticipantsEditionMenus = () => {
  if (document.body.dataset.participantsEditionBound === "true") return
  document.body.dataset.participantsEditionBound = "true"

  document.addEventListener("click", (event) => {
    document.querySelectorAll("details[data-participants-edition][open]").forEach((details) => {
      if (!details.contains(event.target)) details.open = false
    })
  })

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return
    document.querySelectorAll("details[data-participants-edition][open]").forEach((details) => {
      details.open = false
    })
  })
}

const initBackofficeParticipantsBulk = () => {
  document.querySelectorAll("form[data-participants-bulk]").forEach(bindParticipantsBulk)
  bindParticipantsEditionMenus()
}

export { initBackofficeParticipantsBulk }
